export const FROALA_KEY = 'UBB7jD6A3D3F3J3B10aIVLEABVAYFKc1Ce1MYGD1c1NYVMiB3B9B6A5C2C4D4H3I3E3==';
